import { t } from "@/lib/i18n";

export default function CommodityOptions({ meta }) {
  if (!meta.commodity_groups?.length) return meta.commodities.map((c) => <option key={c} value={c}>{t(c)}</option>);
  return meta.commodity_groups.map((g) => (
    <optgroup key={g.label} label={t(g.label)}>
      {g.items.map((c) => <option key={c} value={c}>{t(c)}</option>)}
    </optgroup>
  ));
}
